module.exports = __webpack_public_path__ + "static/sofiapro-300-abbf5a85fd9e6667381a73055f83ab4b.woff";